import {post, get} from 'lib/API';

export const getUnitOfMeasurements = async (
    [_]: any[],
    { token }: any
) => {
    return await get(`v1/measurements`, token);
}

export const upsertUnitOfMeasurements = async (
    [created, updated, deleted]: any[],
    { token }: any
) => {
    const payload = {
        created,
        updated,
        deleted
    }
    return await post(`v1/measurements/upsert`, token, payload);
}